// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2bSkm","row":"ProcedureTreatmentSummary_row__vk0HK"};